import { Link } from "react-router-dom";
import "pages/style.css";

export function NotFoundPage() {
    return (
        <div className="main">
            <h1>Страница не найдена</h1>
            <br />
            <Link to="/">На главную</Link>
        </div>
    );
}
